import React, { useState, useEffect } from "react";
import {
    Col,
    Panel,
    FormGroup,
    Button,
    FormControl,
} from "react-bootstrap";

import { connect } from "react-redux";
import translator from "../../../components/localization/translator";
import { login } from "../login.actions";
import rolesConf from "../../../config/roles";

import pkg from "../../../../package.json";
import "./styles.css";
import jwtHelper from "../../../components/common/jwt/jwtHelper";

const { version } = pkg;

const LoginForm = ({ login, history }) => {

    const [form, setForm] = useState({
        username: "",
        password: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    useEffect(() => {
        const usernameInput = document.querySelector('input[name="username"]');
        const passwordInput = document.querySelector('input[name="password"]');

        if (usernameInput?.value || passwordInput?.value) {
            setForm({
                username: usernameInput?.value || "",
                password: passwordInput?.value || "",
            });
        }
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();

        jwtHelper.deleteToken();
        jwtHelper.deleteRefreshToken();

        const formData = new FormData(e.target);

        const username = formData.get("username");
        const password = formData.get("password");

        if (!username || !password) return;

        login({ username, password }, (data) => {
            history.push(rolesConf.route[data.user.role].home);
        });
    };

    const isDisabled =
        !form.username.trim() || !form.password.trim();

    return (
        <Col xs={12} sm={7} md={3} className="login-container">
            <Panel className="login-form">
                <Panel.Heading>
                    {translator.translate("_welcome_")}
                </Panel.Heading>

                <Panel.Body>
                    <form onSubmit={handleSubmit}>
                        <FormGroup>
                            <FormControl
                                type="text"
                                name="username"
                                autoComplete="username"
                                value={form.username}
                                onChange={handleChange}
                                onInput={handleChange}
                            />
                        </FormGroup>

                        <FormGroup>
                            <FormControl
                                type="password"
                                name="password"
                                autoComplete="current-password"
                                value={form.password}
                                onChange={handleChange}
                                onInput={handleChange}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Button
                                type="submit"
                                bsStyle="primary"
                                block
                                disabled={isDisabled}
                            >
                                {translator.translate("_login_")}
                            </Button>
                        </FormGroup>

                        <span>
                            {translator.translate("_version_")}: v{version}
                        </span>
                    </form>
                </Panel.Body>
            </Panel>
        </Col>
    );
};

export default connect(null, { login })(LoginForm);
